export default __webpack_public_path__ + "static/media/04.8fb24309.jpg";